export const oAuthStyles = (theme) => ({
  root: {
    height: '100%',
    backgroundSize: 'cover',
    paddingTop: theme.spacing(20),
    backgroundRepeat: 'no-repeat',
    backgroundImage: 'url("images/oauth-background.png")',
  },
});
